import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { connect } from 'preact-redux';
import { Component } from 'preact';
import { debounce } from 'diskho';

var SET = 'store/redux_browser_dimensions/SET';

var initialState = {
  width: 0,
  height: 0
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return {
        width: action.width,
        height: action.height
      };
    default:
      return state;
  }
}

var setDimensions = function setDimensions(width, height) {
  return {
    type: SET,
    width: width,
    height: height
  };
};

var WithBrowserDimensionsInner = function (_Component) {
  _inherits(WithBrowserDimensionsInner, _Component);

  function WithBrowserDimensionsInner() {
    _classCallCheck(this, WithBrowserDimensionsInner);

    return _possibleConstructorReturn(this, (WithBrowserDimensionsInner.__proto__ || _Object$getPrototypeOf(WithBrowserDimensionsInner)).apply(this, arguments));
  }

  _createClass(WithBrowserDimensionsInner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onResizeBound = debounce(this.onResize.bind(this));
      this.onResizeBound();
      window.addEventListener('resize', this.onResizeBound, { passive: true });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResizeBound, { passive: true });
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var width = window.innerWidth || document.documentElement.clientWidth;
      var height = window.innerHeight || document.documentElement.clientHeight;

      this.props.set(width, height);
    }
  }, {
    key: 'render',
    value: function render(_ref) {
      var _ref$children = _ref.children,
          children = _ref$children === undefined ? [] : _ref$children;

      if (process.env.NODE_ENV !== "production" && children.length !== 1) {
        console.error("<WithBrowserDimensions /> expects a single child");
      }

      return children[0];
    }
  }]);

  return WithBrowserDimensionsInner;
}(Component);

var WithBrowserDimensions = connect(null, function (dispatch) {
  return {
    set: function set(w, h) {
      return dispatch(setDimensions(w, h));
    }
  };
})(WithBrowserDimensionsInner);

export { reducer, setDimensions, WithBrowserDimensions };
